import { CommonUI } from "@src/common/CommonUI/CommonUI";
import { useResolvedPageLabels } from "@src/hooks/useResolvedPageLabels";
import { Fragment } from "react";
import { CoverCareForm } from "./CoverCareForm";

export const CoverCareStep = () => {
  const labels = useResolvedPageLabels("coverCareStep");

  return (
    <CommonUI
      FormComponent={CoverCareForm}
      headingText={<span>{labels.headingText}</span>}
      bodyText={<Fragment>{labels.bodyText}</Fragment>}
      metaTitle={labels.headingText}
    />
  );
};
